const TOKEN_KEY = 'PARTIPOST_TOKEN'
const NEW_LOGIN_SESSION_KEY = 'PARTIPOST_NEW_LOGIN_SESSION'

export const saveToken = (token: string) => {
    localStorage.setItem(TOKEN_KEY, token)
    // Mark that this is a fresh login session. A page refresh only reads the
    // token (via getToken) and never calls saveToken, so this flag is only set
    // on an actual login.
    try {
        sessionStorage.setItem(NEW_LOGIN_SESSION_KEY, '1')
    } catch {}
}

export const getToken = () => localStorage.getItem(TOKEN_KEY)

export const clearToken = () => localStorage.removeItem(TOKEN_KEY)

// Returns true once per login session, then clears the flag so that subsequent
// refreshes within the same session return false.
export const consumeNewLoginSession = (): boolean => {
    try {
        const isNewLogin = sessionStorage.getItem(NEW_LOGIN_SESSION_KEY) === '1'
        if (isNewLogin) {
            sessionStorage.removeItem(NEW_LOGIN_SESSION_KEY)
        }
        return isNewLogin
    } catch {
        return false
    }
}
